import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasNerja() {
  return (
    <CityPagePersianas
      name="Nerja"
      slug="nerja"
      cp="29780"
      poblacion={22000}
      zonaGeo="Axarquía"
      lat={36.7474}
      lng={-3.8728}
      zonas={[
        "Nerja Centro",
        "Burriana",
        "Maro",
        "Capistrano",
      ]}
      landmarks={[
        "Balcón de Europa",
        "Cuevas de Nerja",
        "Playa Burriana",
        "Acueducto del Águila",
      ]}
      municipiosLimitrofes={[
        "Torrox",
        "Frigiliana",
      ]}
      festivalLocal="Feria de Nerja, mediados de octubre"
      contextoTipologico="Pueblo blanco turístico, alta demanda toldos comerciales en Balcón de Europa, comunidad expat europea."
      isCoreZone={false}
    />
  );
}